<template>
  <div class="home-page">
    <div class="header">
      <div class="cover-img">
        <div class="img"></div>
        <div class="content">
          <CustomHeader></CustomHeader>
          <div class="wrapper">
            <div class="header">
              <div class="header__section pt-lg-5 pt-md-3 pt-sm-2 mt-lg-4">
                <div :class="{ 'show': showContent }" class="header__section-info">
                  <div class="title">
                    {{ $t('ups.title') }}
                  </div>
                </div>
                <transition name="fade">
                  <div v-if="showImage" class="header__section-img"></div>
                </transition>
              </div>
            </div>
            <div class="description" ref="description">
              <b>Albat Energy Systems:</b> <br>
              {{ $t('ups.description') }}
            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="body-section">
      <div class="content">
        <BoxSection
            position="left"
            :title="$t('ups.atlus')"
            :descriptionLines="[
              $t('ups.atlusDesc1'),
              $t('ups.atlusDesc2'),
              $t('ups.atlusDesc3'),
              $t('ups.atlusDesc4'),
              $t('ups.atlusDesc5'),
              $t('ups.atlusDesc6'),
              $t('ups.atlusDesc7')
            ]"
            pdfLink="/pdfs/ups/UPS-SERIES-ATLUS-RACK-COM-10-20KVA_KW.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/ups/Atlus-Rack-Com.png"
        />
        <BoxSection
            position="right"
            :title="$t('ups.atlusSaurus')"
            :description="$t('ups.atlusSaurusDesc')"
            pdfLink="/pdfs/ups/UPS-SERIES-SAURUS.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/ups/ATLUS-SAURUS-KVA.png"
        />
        <BoxSection
            position="left"
            :title="$t('ups.atlusSaurus2')"
            :description="$t('ups.atlusSaurusDesc2')"
            pdfLink="/pdfs/ups/UPS-SERIES-SAURUS-10-40-1.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/ups/Albat-Atlus-Saurus.png"
        />
        <BoxSection
            position="right"
            :title="$t('ups.saurusMod')"
            :description="$t('ups.saurusModDesc')"
            pdfLink="/pdfs/ups/UPS-SERIES-SAURUS-MOD.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/ups/SAURUS.png"
        />
        <BoxSection
            position="left"
            :title="$t('ups.atlusTower')"
            :description="$t('ups.atlusTowerDesc')"
            pdfLink="/pdfs/ups/UPS-SERIES-ATLUS.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/ups/altus-tower.png"
        />
        <BoxSection
            position="right"
            :title="$t('ups.atlusTower2')"
            :description="$t('ups.atlusTowerDesc2')"
            pdfLink="/pdfs/ups/UPS-SERIES-ATLUS-RACK.pdf"
            :pdfLabel="$t('pdf')"
            imageSrc="/img/ups/ATLUS-RACK-TOWER.png"
        />
    </div>
<!--        <div class="content">
          <div class="box box__left" :class="{ 'show': showLeft}">
            <div class="blue-container blue-container__left">
              <div class="container-content">
                <div class="container-content__title">
                  {{ $t('ups.atlus') }}
                </div>
                <div class="container-content__description container-content__description-left">

                  {{ $t('ups.atlusDesc1') }}
                  <br>
                  {{ $t('ups.atlusDesc2') }}
                  <br>
                  {{ $t('ups.atlusDesc3') }}
                  <br>
                  {{ $t('ups.atlusDesc4') }}
                  <br>
                  {{ $t('ups.atlusDesc5') }}
                  <br>
                  {{ $t('ups.atlusDesc6') }}
                  <br>
                  {{ $t('ups.atlusDesc7') }}

                </div>
                <div class="container-content__pdfs">
                  <a href="/pdfs/ups/UPS-SERIES-ATLUS-RACK-COM-10-20KVA_KW.pdf" target="_blank" class="btn">
                    {{ $t('pdf') }}
                  </a>
                </div>
              </div>
              <img class="box-img box-img&#45;&#45;left" src="~@/assets/images/ups/Atlus-Rack-Com.png" alt="" loading="lazy">

            </div>

          </div>

          <div class="box box__right" :class="{ 'show': showRight }">
            <div class="blue-container blue-container__right">
              <div class="container-content">
                <div class="container-content__title">
                  {{ $t('ups.atlusSaurus') }}
                </div>
                <div class="container-content__description container-content__description-right">
                  {{ $t('ups.atlusSaurusDesc') }}
                </div>
                <div class="container-content__pdfs container-content__pdfs-right">
                  <a href="/pdfs/ups/UPS-SERIES-SAURUS.pdf" target="_blank" class="btn">  {{ $t('pdf') }} </a>
                </div>
              </div>
              <img class="box-img box-img&#45;&#45;right" src="~@/assets/images/ups/ATLUS-SAURUS-KVA.png" alt="" loading="lazy">
            </div>
          </div>

          <div class="box box__left" :class="{ 'show': showLeft2 }">
            <div class="blue-container blue-container__left">
              <div class="container-content">
                <div class="container-content__title">
                  {{ $t('ups.atlusSaurus2') }}
                </div>
                <div class="container-content__description container-content__description-left">
                  {{ $t('ups.atlusSaurusDesc2') }}
                </div>
                <div class="container-content__pdfs">
                  <a href="/pdfs/ups/UPS-SERIES-SAURUS-10-40-1.pdf" target="_blank" class="btn">  {{ $t('pdf') }} </a>
                </div>
              </div>
              <img class="box-img box-img&#45;&#45;left" src="~@/assets/images/ups/Albat-Atlus-Saurus.png" alt="" loading="lazy">
            </div>
          </div>

          <div class="box box__right" :class="{ 'show': showRight2 }">
            <div class="blue-container blue-container__right">
              <div class="container-content">
                <div class="container-content__title">
                  {{ $t('ups.saurusMod') }}
                </div>
                <div class="container-content__description container-content__description-right">
                  {{ $t('ups.saurusModDesc') }}
                </div>
                <div class="container-content__pdfs container-content__pdfs-right">
                  <a href="/pdfs/ups/UPS-SERIES-SAURUS-MOD.pdf" target="_blank" class="btn">  {{ $t('pdf') }} </a>
                </div>
              </div>
              <img class="box-img box-img&#45;&#45;right" src="~@/assets/images/ups/SAURUS.png" alt="" loading="lazy">
            </div>
          </div>

          <div class="box box__left" :class="{ 'show': showLeft3}">
            <div class="blue-container blue-container__left">
              <div class="container-content">
                <div class="container-content__title">
                  {{ $t('ups.atlusTower') }}
                </div>
                <div class="container-content__description container-content__description-left">
                  {{ $t('ups.atlusTowerDesc') }}
                </div>
                <div class="container-content__pdfs">
                  <a href="/pdfs/ups/UPS-SERIES-ATLUS.pdf" target="_blank" class="btn">  {{ $t('pdf') }}</a>
                </div>
              </div>
              <img class="box-img box-img&#45;&#45;left" src="~@/assets/images/ups/altus-tower.png" alt="" loading="lazy">
            </div>
          </div>

          <div class="box box__right" :class="{ 'show': showRight3 }">
            <div class="blue-container blue-container__right">
              <div class="container-content">
                <div class="container-content__title">
                  {{ $t('ups.atlusTower2') }}
                </div>
                <div class="container-content__description container-content__description-right">
                  {{ $t('ups.atlusTowerDesc2') }}
                </div>
                <div class="container-content__pdfs container-content__pdfs-right">
                  <a href="/pdfs/ups/UPS-SERIES-ATLUS-RACK.pdf" target="_blank" class="btn">  {{ $t('pdf') }}</a>
                </div>
              </div>
              <img class="box-img box-img&#45;&#45;right" src="~@/assets/images/ups/ATLUS-RACK-TOWER.png" alt="" loading="lazy">
            </div>

         </div>
        </div>-->

      <MarqueeLogos />

    </div>
    <div class="footer">
      <div class="cover-img">
        <div class="img">
          <div class="img3"></div>
        </div>
        <div class="content">
          <FooterSection></FooterSection>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import FooterSection from "@/components/Footer.vue";
import CustomHeader from "@/components/CustomHeader.vue";
import BoxSection from "@/components/BoxSection.vue";
import MarqueeLogos from "@/components/MarqueeLogos.vue";

export default {
  name: 'AvioOprema',
  components: {
    FooterSection,
    CustomHeader,
    BoxSection,
    MarqueeLogos
  },
  data() {
    return {
      showImage: false,
      showContent: false,
    };
  },
  mounted() {
    this.showImage = true;
    setTimeout(() => {
      this.showContent = true;
    }, 500);
    setTimeout(() => {
      this.$nextTick(() => {
        this.$refs.description.classList.add('fade-in');
      });
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/main.scss";

.home-page {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin: 0;
  padding: 0;
  overflow-y: auto;
}

.header {
  position: relative;
  overflow: hidden;

  .cover-img {
    .img {
      background-image: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.85) 85%), url('@/assets/images/top-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      width: 100%;
      height: 1100px;
      @include respond(lil-phone) {
        height: 1250px !important;
      }
      @include respond(phone) {
        height: 1130px;
      }
    }

    img {
      position: relative;
      top: 5px;
    }

    .content {
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}

.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    width: 70vw;
    @include respond(tab-land) {
      width: 95vw;
    }
    @media only screen and (min-width: 1201px) and (max-width: 1499px) {
      width: 95vw;
    }

    &__section {
      display: flex;
      width: 100%;
      justify-content: space-between;
      //   align-items: flex-start;
      align-items: center;
      margin-top: 40px;
      @include respond(phone) {
        flex-direction: column;
        margin-top: 20px;
      }

      &-info {
        display: flex;
        flex-direction: column;
        gap: 10px;
        max-width: 530px;
        width: 100%;
        text-align: left;

        transform: translateY(-100%);
        opacity: 0;
        transition: transform 1.2s ease-out, opacity 2s ease-out;
        @include respond(phone) {
          text-align: center;
        }

        &.show {
          transform: translateX(0);
          opacity: 1;
        }

        .title {
          font-size: 100px;
          font-family: "Montserrat";
          color: $primary-blue;
          font-weight: bold;
          text-transform: uppercase;
          line-height: 0.938;
          text-align: center;
          @include respond(phone) {
            font-size: 30px !important;
            width: 100%;
          }
        }

      }

      .fade-enter-active, .fade-leave-active {
        transition: opacity 1s ease-in;
      }

      .fade-enter-from, .fade-leave-to {
        opacity: 0;
      }

      .fade-enter-to, .fade-leave-from {
        opacity: 1;

      }

      &-img {
        background-image: url('~@/assets/images/Naslovna-ALBAT-ENERGY.png');
        border-radius: 10px;
        width: 500px;
        height: 180px;
        background-size: cover;
        @include respond(phone) {
          display: block !important;
          width: 90vw;
          height: 150px;
          border-radius: 8px;
        }
      }
    }

    .title {
      font-size: 50px;
      font-family: "Montserrat";
      color: $primary-blue;
      font-weight: bold;
      text-transform: uppercase;
      line-height: 1.3;
      @include respond(from-phone-to-tab) {
        font-size: 40px;
      }
    }
  }

  .description {
    max-width: 70vw;
    text-align: center;
    color: $primary-blue;
    font-size: 22px;
    margin-top: 80px;
    font-family: "Karla";
    opacity: 0;
    transition: opacity 3s ease-out;
    @include respond(phone) {
      text-align: justify;
      margin-top: 40px;
      font-size: 20px;
      max-width: 95vw;
    }
    @include respond(lil-phone) {
      margin-top: 20px;
    }
  }

  .pdfs {
    max-width: 70vw;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 20px;

    .pdf {
      .btn {
        background-color: $primary-blue;
        color: white;
        padding: 10px 30px;
        text-transform: uppercase;
        text-decoration: none;
        font-weight: bold;
        transition: transform 0.7s ease-out, color 1s ease;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  .description.fade-in {
    opacity: 1;
  }
}

.footer {
  position: relative;
  overflow: hidden;

  .cover-img {
    .img {
      position: relative;
      // display: flex;
      //  flex-direction: column;
    }

    .img3 {
      background-image: linear-gradient(to top, rgba(88, 135, 198, 0.74), #5887C6BD), linear-gradient(to bottom, rgb(88, 135, 198, 0.74), #5887C6BD), url('@/assets/images/bottom-bg.png');
      background-repeat: no-repeat;
      background-size: cover;
      // position: relative;
      width: 100%;
      height: 950px;
      @include respond(from-phone-to-tab) {
        height: 620px;
      }
      @include respond(phone) {
        height: 650px;
      }
    }

    img {
      position: relative;
      top: 5px;
    }

    .content {
      position: absolute;
      top: 0;
      width: 100%;
    }
  }
}

</style>
